// Política de contraseña (2026-09-13, pedido de Sue: la pantalla de crear
// contraseña debe indicar sus condiciones) — mismo mínimo que valida el
// servidor (`MIN_CONTRASENA`, packages/web/src/api/lib/politica-contrasena.ts;
// 12 desde MT-047). El servidor además rechaza contraseñas comunes, filtradas,
// iguales al usuario, repetidas o secuenciales: eso no se repite acá.
// Esto es SOLO para mostrar la lista y deshabilitar "Guardar" hasta
// cumplirla; la validación real que importa es la del servidor.
export type ReglaContrasena = { id: string; label: string; cumple: (password: string) => boolean };

export const REGLAS_CONTRASENA: readonly ReglaContrasena[] = [
  { id: 'longitud', label: 'Al menos 12 caracteres', cumple: (p) => p.length >= 12 },
  { id: 'mayuscula', label: 'Al menos una letra mayúscula', cumple: (p) => /[A-Z]/.test(p) },
  { id: 'minuscula', label: 'Al menos una letra minúscula', cumple: (p) => /[a-z]/.test(p) },
  { id: 'especial', label: 'Al menos un carácter especial (! @ # $ % & …)', cumple: (p) => /[^A-Za-z0-9]/.test(p) },
];

export function contrasenaCumplePolitica(password: string): boolean {
  return REGLAS_CONTRASENA.every((r) => r.cumple(password));
}
